import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import AdminPage from "../../components/AdminPage";
import TableComponent from "../../components/adminTableComponent";
import { LoaderWrapper } from "../../components/LoaderWrapper";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import { SpecificView } from "../../components/SpecificView/SpecificView";
import { AddSkill } from "./AddSkill";
import { loadSkills } from "./loadData";
import { SkillsHeaders } from "./tableHeaders";

const Skills = ({}) => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [skills, setSkills] = useState([]);
  const [opened, setOpened] = useState(false);
  const [update, setUpdate] = useState(false);
  const [viewModalData, setViewModalData] = useState({});
  const [viewModalState, setViewModalState] = useState(false);

  useEffect(() => {
    loadSkills(setLoading).then(setSkills);
  }, [location.pathname, update]);

  return (
    <AdminPage title="Skills">
      <ModalWrapper
        opened={viewModalState}
        setOpened={setViewModalState}
        title={"Skill Details"}
        InternalComponent={
          <SpecificView
            name={viewModalData.skillName}
            description={viewModalData.skillDescription}
            date={viewModalData?.createdDate}
            status={viewModalData?.state}
          />
        }
      />
      <LoaderWrapper loading={loading}>
        <AddSkill opened={opened} setOpened={setOpened} setUpdate={setUpdate} />
        <TableComponent
          headCells={SkillsHeaders}
          rowData={skills}
          opened={opened}
          setOpened={setOpened}
          showAddButton={true}
          setViewModalData={setViewModalData}
          setViewModalState={setViewModalState}
        />
      </LoaderWrapper>
    </AdminPage>
  );
};

export default withTranslation()(Skills);
